module.exports = __webpack_public_path__ + "img/cs_logo_round.f13dd54e.png";